module.exports = __webpack_public_path__ + "components/weather-icon/static/daysnowshowers-0410c31958e2d478d103b693983eabae.png";